/* eslint-disable react-refresh/only-export-components */
// context/UserProfileContext.tsx
import type {ReactNode} from 'react';
import {createContext, useCallback, useContext, useEffect} from 'react';

import {useGetProfileQuery} from '@/gql-codegen/generated';
import {useProfileStore} from '@/hooks/global-stores/profile.store';

type TUserProfileContext = {
  profile?: ReturnType<typeof useProfileStore.getState>['user'];
  profileFetching: boolean;
  refetchProfile: () => void;
};

const UserProfileContext = createContext<TUserProfileContext>({
  profile: undefined,
  profileFetching: true,
  refetchProfile: () => {},
});

export const useUserProfileContext = () => useContext(UserProfileContext);

export const UserProfileProvider = ({children}: {children: ReactNode}) => {
  const [{data: profileData, fetching: profileFetching}, reexecuteQuery] =
    useGetProfileQuery();
  const setUser = useProfileStore(s => s.setUser);
  const profile = useProfileStore(s => s.user);

  useEffect(() => {
    if (profileData?.profile) {
      setUser(profileData.profile);
    }
  }, [profileData?.profile, setUser]);

  const refetchProfile = useCallback(() => {
    reexecuteQuery({requestPolicy: 'network-only'});
  }, [reexecuteQuery]);

  return (
    <UserProfileContext.Provider
      value={{
        profile,
        profileFetching,
        refetchProfile,
      }}>
      {children}
    </UserProfileContext.Provider>
  );
};
